define([
  'js/aofl-js/0.8.0/app/app',
  'text!readingiq-src/js/riq-js/riq-progress-bar/1.0.0/index.html',
  'text!readingiq-src/js/riq-js/riq-progress-bar/1.0.0/index.css'
], function riqProgressBarModule(app, html, css) {
  'use strict';

  app.registerComponent('riqProgressBar', {
    bindings: {
      total: '<',
      completed: '<',
      showText: '@'
    },
    controller: 'riqProgressBarController',
    template: html
  });

  app.registerController('riqProgressBarController', [
    '$scope',
    '$element',
    'compileService',
    function riqProgressBarController($scope, $element, compileService) {
      var vm = this;

      $scope.$watchCollection('[$ctrl.total, $ctrl.completed]', function(
        newValues
      ) {
        var total = newValues[0];
        var completed = newValues[1];
        var barPercent = Math.floor(
          (parseInt(completed, 10) / parseInt(total, 10)) * 100
        );
        vm.completed = parseInt(vm.completed, 10);
        vm.barPercent = isNaN(barPercent) ? 0 : barPercent;
        vm.barCompleted = vm.barPercent >= 100;
        vm.barPercent += '%';
      });

      compileService.compile(
        {
          css: css
        },
        $scope,
        $element
      );
    }
  ]);
});
